import "./DisconnectModal.scss"
import { FC, useEffect } from "react"
import {  Link } from "@mui/material"
import LoadingButton from '@mui/lab/LoadingButton'
import CircularProgress from '@mui/material/CircularProgress'
import {
  disconnectDriverAsync,
  getDriversAsync,
  setDisconnectDriverSuccess,
} from "../../../redux/slices/driverSlice"
import { useAppDispatch } from "../../../redux/hooks"
import GenericModal from "../GenericAppModal/GenericModal.component"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import { useSelector } from "react-redux"
import { RootState } from "../../../redux/store"

type DisconnectModalProps = {
  open: boolean
  handleClose: () => void,
  driverId?: number,
  driverStatusId?: number,
}

const DisconnectModal: FC<DisconnectModalProps> = ({ open, handleClose, driverId, driverStatusId }) => {
  const {
    DISCONNECT_DRIVER_MODAL_TITLE,
    DISCONNECT_DRIVER_MODAL_DESCRIPTION,
    DISCONNECT_DRIVER_MODAL_BTN,
    DISCONNECT_DRIVER_MODAL_SUB_BTN,
  } = useTranslationLabel()

  const dispatch = useAppDispatch()

  const disconnectDriverLoading = useSelector(
    (state: RootState) => state.driver.disconnectDriverLoading,
  )
  
  const disconnectDriverSuccess = useSelector(
    (state: RootState) => state.driver.disconnectDriverSuccess,
  )

  useEffect(() => {
    if (disconnectDriverSuccess) {
      dispatch(getDriversAsync())
      handleClose()
      dispatch(setDisconnectDriverSuccess())
    }
  }, [disconnectDriverSuccess]);

  return (
    <GenericModal
      open={open}
      handleClose={handleClose}
      title={DISCONNECT_DRIVER_MODAL_TITLE}
      className="add-driver"
      description={DISCONNECT_DRIVER_MODAL_DESCRIPTION}
    >
      <div className="form-container column">
        <LoadingButton
          variant="contained"
          className="primary-btn"
          loadingIndicator={
            <CircularProgress size={24} sx={{ color: 'white' }} />
          }
          loading={disconnectDriverLoading}
          onClick={() => {
            dispatch(disconnectDriverAsync({ driverId: driverId, disconnect: driverStatusId === 2 }))
          }}
        >
          {DISCONNECT_DRIVER_MODAL_BTN}
        </LoadingButton>

        <Link variant="body1" className="sub-btn" onClick={handleClose}>
          {DISCONNECT_DRIVER_MODAL_SUB_BTN}
        </Link>
      </div>
    </GenericModal>
  )
}

export default DisconnectModal
